export const PrismicRepositoryType = {
  BUSINESS: 'business',
  TECHNICAL: 'technical',
};

export const DESKTOP_MINIMAL_WIDTH = 900;
